import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/points', pathMatch: 'full' },
  {
    path: '',
    loadChildren: async () => import('./main/main.module').then((m) => m.MainModule),
  },
  { path: '**', redirectTo: '/points' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
